import React from 'react';
import { IconBase } from '../Base';
export const IconJPY = (props) => (React.createElement(IconBase, { ...props, viewportSize: 24 },
    React.createElement("path", { d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: "#F0F0F0" }),
    React.createElement("path", { d: "M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z", fill: "#D80027" }),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_2_9288" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })))));
//# sourceMappingURL=JPY.js.map